import React from 'react';

const MapArea = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      id="mapArea"
      style={{
        height: '100%',
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
        marginBottom: '16px',
        flexGrow: 9,
        flexBasis: '50vh'
      }}
    >
      {children}
    </div>
  );
};

export default MapArea;
